import React, { useState, useEffect } from "react";
import { Button, TextField, FormControl } from "@mui/material";
import * as _ from 'lodash'

import { formatCurrency } from "../../helpers/utils";
import { getStatus } from "../../constants/theme";
import { gas_types } from "../../constants/common";
import RadioGroupCustom from '../radio_group_chip';
import SwitchCustom from "../switch";


const CardConfig = ({cardConfig, setCardConfig}) => {
  const [limitType, setLimitType] = useState(0)
  const [hidePassword, setHidePassword] = useState(true)
  const [active, setActive] = useState(true)

  useEffect(() => {
    if (!_.isEmpty(cardConfig)) {
      setActive(cardConfig.status === 'active')
    }
  }, [cardConfig])

  return (
    <>
      <div className="font-size-20 font-weight-bold mt-2">
        Лимит тохируулах
      </div>
      <div className="bordered-input d-inline-flex mt-3">
        <Button
          onClick={() => setLimitType(0)}
          className={`bg-${limitType === 0 ? 'primary-light' : 'white'} text-${limitType === 0 ? 'primary' : 'dark'} btn-sm`}
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Мөнгөн дүнгээр</span>
        </Button>
        <Button
          onClick={() => setLimitType(1)}
          className={`bg-${limitType === 1 ? 'primary-light' : 'white'} text-${limitType === 1 ? 'primary' : 'dark'} btn-sm`}
          variant="contained"
          disableElevation
        >
          <span className="mx-2">Литрээр</span>
        </Button>
      </div>
      <div className="d-flex mt-4">
        {
          limitType === 1 && <select defaultValue={0} 
            className="form-select custom-dropdown w-auto ms-2">
            {
              gas_types.map((g, i) => (
                <option key={`gas_types_${g}`} value={g}>{g}</option>
              ))
            }
          </select>
        }
        <TextField 
          className="w-100 dialog-inputs" 
          label={limitType === 0 ? "0.00₮" : "0л"}
          variant="outlined"
          type={'number'}
          value={cardConfig.limit ?? ''}
          onChange={(e) => setCardConfig({...cardConfig, limit: e.target.value})}
        /> 
      </div>
      <div className="mt-2 d-flex flex-wrap">
        {
          (limitType === 0 ? [10000, 20000, 30000, 50000, 100000] : [5, 10, 20, 30, 50]).map(v => (
            <Button
              key={`button-amount-${v}`}
              onClick={() => setCardConfig({...cardConfig, limit: v})}
              className='btn-bordered-sm bg-white px-1 ms-2 my-1'
              variant="contained"
              disableElevation
            >
              <span className="mx-2 font-weight-400">{limitType === 0 ? formatCurrency(v) : `${v}л`}</span>
            </Button>
          ))
        }
      </div>
      <div className="font-size-20 font-weight-bold mt-5">
        Бүтээгдэхүүн түгжих
      </div>
      <div className="d-flex flex-wrap pe-2 mt-3" style={{maxWidth: '700px'}}>
        <FormControl>
          <RadioGroupCustom 
            value={cardConfig.locked ?? ''}
            setValue={value => setCardConfig({...cardConfig, locked: value})}
            options={gas_types}
          />
        </FormControl>
      </div>
      <div className="font-size-20 font-weight-bold mt-5">
        Картын тохиргоо
      </div>
      <TextField 
        className="mt-3 w-100 dialog-inputs" 
        label="Пин код" 
        variant="outlined"
        type={!hidePassword ? 'text' : 'password'}
        value={cardConfig.pin ?? ''}
        onChange={(e) => setCardConfig({...cardConfig, pin: e.target.value})}
      /> 
      <div className="d-flex ms-n2 align-items-center">
        <SwitchCustom 
          value={hidePassword}
          handleChange={(e) => setHidePassword(e.target.checked)}
        />
        <div className="font-size-14 font-weight-500">Нууц үг нуух</div>
      </div>
      <div className="row" style={{maxWidth: 730}}>
        <div className="col-12 col-md-6">
          <div className="bordered py-3 px-4 mt-3 bg-light">
            <div className="font-size-14 text-grey">{getStatus(active)}</div>
            <div className="my-3">Картын төлөвийг идэвхгүй болгох бол идэвхгүй болох товчин дээр дарна уу.</div>
            <div className="d-flex ms-n2 align-items-center">
              <SwitchCustom 
                value={active}
                handleChange={(e) => setActive(e.target.checked)}
              />
              <div className="font-size-14 font-weight-500">Идэвхитэй</div>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="bordered py-3 px-4 mt-3 bg-light">
            <div className="mb-3">Картыг устгах бол устгах товчин дээр дарж устгана уу.</div>
            <Button
              className='btn-bordered-sm-danger px-1 ms-2 my-1'
              variant="contained"
              disableElevation
            >
              <span className="mx-2">Карт устгах</span>
            </Button>
          </div>
        </div>
      </div>

    </>
  )
}


export default CardConfig;